// Analytics initialization component that loads consent mode immediately
// This should be added to your App.js or main component

import { useEffect } from 'react';
import { loadGoogleAnalytics, updateAnalyticsConsent } from '../utils/analyticsWithConsentMode';
import { getCookiePreferences, hasCookieConsent } from '../utils/cookieManager';
import { initializeUTMTracking } from '../utils/utmTracking';

const AnalyticsInitializer = () => {
  useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        // Always load Google Analytics with consent mode (allows basic tracking)
        await loadGoogleAnalytics();
        console.log('Google Analytics loaded with consent mode on app start');
        
        // Initialize UTM tracking (no cookies required)
        initializeUTMTracking();
        
        // If user has already given consent, update consent mode
        if (hasCookieConsent()) {
          const preferences = getCookiePreferences();
          updateAnalyticsConsent(preferences.analytics, preferences.marketing);
          console.log('Analytics consent updated based on existing preferences');
        }
      } catch (error) {
        console.error('Failed to initialize analytics:', error);
      }
    };

    initializeAnalytics();
  }, []);

  // This component doesn't render anything
  return null;
};

export default AnalyticsInitializer;
